import React from 'react';
import PropTypes from 'prop-types';

import HubModel from 'models/hub';
import Brand from 'models/brand';

import FeaturedDestinations from 'components/hub/featured-destinations';
import NycOrRegularPopularDestinations from 'components/hub/nyc-or-regular-popular-destinations';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const CityDetails = ({ hub, brand }) => {
  if (!hub.city) { return null; }

  return (
    <div>
      <div className="row">
        <div className="section-title text-center h1-sg text-color-slate text-weight-bold">Grab the best spot in town.</div>
        <div className="section-subtitle text-center h2-sg text-color-dark-slate text-weight-medium bottom">Now there&#39;s no reason not to go </div>
      </div>
      <FeaturedDestinations
        hub={hub}
        brand={brand}
      />
      <div className="row popular-destinations-wrapper">
        <NycOrRegularPopularDestinations hub={hub} brand={brand} />
      </div>
    </div>
  );
};

CityDetails.propTypes = propTypes;

export default CityDetails;
